import { Card } from '../ui';

type Props = { dna?: Record<string, string> };

export function VisualDNAEngineCard({ dna = {} }: Props) {
  return (
    <Card padding="sm" className="border-brand-200 bg-brand-50/20 dark:border-brand-900 dark:bg-brand-950/20">
      <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">Visual DNA Engine</p>
      <div className="mt-3 space-y-2">
        {Object.entries(dna).map(([key, value]) => (
          <div key={key} className="rounded border border-brand-200/60 bg-white/60 px-2 py-1.5 text-xs dark:border-brand-800 dark:bg-slate-900/60">
            <span className="font-medium text-brand-700 dark:text-brand-300">{key}: </span>
            <span className="text-slate-600 dark:text-slate-400">{value}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
